import {Button, ButtonProps} from "@mui/material";
import {ReactElement} from "react";
import {SZ_SMSM} from "@/shared/dimens";

export function LargeButton(props: ButtonProps): ReactElement {
  return <Button {...props} style={{height: SZ_SMSM}}/>;
}